<template>
  <el-dialog :title="`上传`" :width="pda.status ? '90%' :  (frameWidth  || '800px')" class="picture-select" :visible.sync="visible" :append-to-body="true">
    <el-tabs v-model="activeTab">
      <!-- 照片 -->
      <el-tab-pane :label="`照片`" name="image">
        <image-upload ref="image" v-if="activeTab === 'image'" @complete="complete" />
      </el-tab-pane>
      <!-- 拍照 -->
      <el-tab-pane :label="`拍照`" name="photo">
        <photo-upload ref="photo" v-if="activeTab === 'photo'" @complete="complete" />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ImageUpload from './ImageUpload.vue'
import PhotoUpload from './PhotoUpload.vue'
import { getDict } from '@/api.js'
export default {
  name: 'PictureSelect',
  components: {
    ImageUpload,
    PhotoUpload
  },
  computed: {
      ...mapGetters(['pda'])
    },
  props: {
    type: {
      type: String,
      default: 'image/*', // video/* audio/* image/* .pdf .xls .doc
    },
    
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        if (this.$refs.photo) {
          this.$refs.photo.closeCamera()
          this.$refs.photo.reset()
        } else if (this.$refs.image) {
          this.$refs.image.reset()
        }
      } else {
        if (this.$refs.photo) {
          this.$refs.photo.checkAndPlay()
        }
      }
    }
  },
  data() {
    return {
      activeTab: 'image',
      visible: false,
      frameWidth: ''
    }
  },
  created() {
    this.getFrameWidth()
  },
  methods: {
    reset() {
      if (this.activeTab === 'image') {
        this.$refs.image.reset()
      } else if (this.activeTab === 'photo') {
        this.$refs.photo.reset()
      }
    },
    complete(list) {
      this.$emit('complete', list)
      this.reset()
      this.visible = false
    },
    show() {
      this.visible = true
    },
    getFrameWidth() {
      // 获取拍照区域大小
      if (this.frameWidth) return
      this.$request('get', getDict, {type: 401})
			.then((res) => {
				this.frameWidth = res[0] ? res[0]['name'] : ''
			})
    }
  }
}
</script>

<style lang="scss" scoped>
  .picture-select {
    /deep/ .el-dialog {
      margin-top: 4vh !important;
    }
    /deep/ .el-dialog__body {
      padding-top: 0 !important;
    }
  }
</style>